import React from 'react';
import { Link } from 'react-router-dom';
import { Settings } from '../configuration/settings';
import { ModelDetails } from '../configuration/model-description';
import { useState } from 'react';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => setIsOpen(!isOpen);

  const closeNavbar = () => setIsOpen(false);

  return (
    <header className="sticky-top">
      <nav className="navbar navbar-expand-lg bg-light py-1">
        <div className="container container-fluid">
          <button className="navbar-toggler p-1 border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" onClick={toggleNavbar} aria-expanded={isOpen} aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Centered logo by mx-auto*/}
          <Link className="navbar-brand mx-auto" to="/" title={`${Settings.shopName} - інтернет-магазин оригінальних джинсів Levi’s`}>
            <img style={{ width: 40, height: 40 }} src="/logo96.png" alt={`Логотип магазину ${Settings.shopName}`} />
            <span className="text-uppercase fw-semibold fs-2 align-middle" style={{ letterSpacing: "0.1rem" }}>{Settings.shopName}</span>
          </Link>
           {/* Hidden right burger button for correct logo centering*/}
          <button className="navbar-toggler p-1 invisible" type="button">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to="/" title="Чоловічі джинси Levi’s" onClick={closeNavbar}>
                  Чоловічі джинси Levi’s
                </Link>
              </li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" title="Моделі Levi’s">
                  Моделі Levi’s
                </a>
                <ul className="dropdown-menu bg-light">
                  <li>
                    <Link className="dropdown-item link-secondary" to="/" title="Усі джинси Levi’s" onClick={closeNavbar}>
                      Переглянути усі
                    </Link>
                  </li>
                  {
                    Object.keys(ModelDetails).map(model => 
                      <li>
                        <Link className="dropdown-item link-secondary" to={`/m/levis-${model}/`} title={`Джинси Levi’s ${model}`} onClick={closeNavbar}>
                          Джинси Levi’s {model}
                        </Link>
                      </li>
                    )
                  }
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" title="Корисно">
                  Корисно
                </a>
                <ul className="dropdown-menu bg-light">
                  <li>
                    <Link className="dropdown-item link-secondary" to="/tablytsia-rozmiriv-levis/" title="Розмірна сітка джинсів Levi’s" onClick={closeNavbar}>
                      Розмірна сітка джинсів Levi’s
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item link-secondary" to="/yak-robyty-zamiry-dzhyns-levis/" title="Як правильно робити заміри джинсів Levi’s" onClick={closeNavbar}>
                      Як правильно робити заміри джинсів Levi’s
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item link-secondary" to="/yak-pereviryty-oryhinalnist-dzhynsiv-levis/" title="Як перевірити оригінальність джинсів Levi’s" onClick={closeNavbar}>
                      Як перевірити оригінальність джинсів Levi’s
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about/" title="Про нас" onClick={closeNavbar}>
                  Про нас
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/delivery-and-payment/" title="Доставка і оплата" onClick={closeNavbar}>
                  Доставка і оплата
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contacts/" title="Контакти" onClick={closeNavbar}>
                  Контакти
                </Link>
              </li>
            </ul>
            {/*
          <form className="d-flex" role="search">
            <input className="form-control me-2" type="search" placeholder="Пошук" aria-label="Пошук" />
            <button className="btn btn-outline-success" type="submit">Пошук</button>
          </form>
          */}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
